export default "174e13b5edc80b92395e86f031d1a301.png";